import React from "react";
import { Col, Row, Stack } from "react-bootstrap";
import { User } from "../../types/user";
import PageTitle from "../ui/PageTitle";
import GuardianCard from "./GuardianCard";

interface GuardianTabState {
  users: User[];
}

const GuardianTab = ({ users }: GuardianTabState) => {
  return (
    <>
      <Row className="mb-5">
        <Col xs={12}>
          <Stack gap={3}>
            <PageTitle title="Primary Adults" type="section" />
            {users.length > 0 ? (
              users
                .slice()
                .sort((a: any, b: any) => {
                  // Sort by casename first
                  const caseCompare = (a.casename || "").localeCompare(b.casename || "");
                  if (caseCompare !== 0) {
                    return caseCompare;
                  }
                  // Then sort by firstname
                  return (a.firstname || "").localeCompare(b.firstname || "");
                })
                .map((user: any) => <GuardianCard user={user} />)
            ) : (
              <p className="mt-2">No Primary Adult User Records</p>
            )}
          </Stack>
        </Col>
      </Row>
    </>
  );
};

export default GuardianTab;
